<template>
  <v-container fluid>
    <v-card class="elevation-1" outlined>
      <v-toolbar flat>
        <v-toolbar-title class="headline">
          <v-icon left>fas fa-atlas</v-icon>Forge Nano Materials
        </v-toolbar-title>
        <v-spacer/>
        <MaterialForm :is-edit="false"/>
        <v-btn icon @click.native="initialize">
          <v-icon>refresh</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-btn small @click="getArchived" :loading="loading">
            Get Archived
          </v-btn>
          <v-spacer/>
          <v-text-field
            v-model="search"
            prepend-inner-icon="search"
            single-line
            hide-details
            clearable
          />
        </template>
      </v-toolbar>
      <MaterialsTable
        :loading="loading"
        :search="search"
        :materials="materials"
      />
    </v-card>
  </v-container>
</template>

<script>
import Material from "../../models/Material";
import MaterialsTable from "../../components/Material/MaterialsTable";
import MaterialForm from "../../components/Material/MaterialForm";
export default {
  name: "Materials",
  components: { MaterialsTable, MaterialForm },
  data() {
    return {
      loading: true,
      search: "",
      showArchived: false
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    materials() {
      if (this.showArchived) {
        return Material.query()
          .withAll()
          .get();
      } else {
        return Material.query()
          .where("archived", false)
          .withAll()
          .get();
      }
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Material
        .$fetchActive()
        .then(() => this.loading = false)
    },
    getArchived() {
      this.showArchived = true;
      this.loading = true;
      Material
        .$fetchAll()
        .then(() => (this.loading = false));
    }
  }
};
</script>
